export const LOCALIZATION_KEY = 'builder.resume_distribution.version_3'
